import React from 'react';
import ReactLoading from "react-loading";

import style from './style.css';

const LOADING_CONFIG = {
  type: 'spin',
  color: '#aaaaaa',
};

export default class Loading extends React.Component {
  render() {
    return (
      <ReactLoading
       type={LOADING_CONFIG.type}
       color={LOADING_CONFIG.color}
       className={style.loading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/loading/index.js